import RelatedProducts from './RelatedProducts';

export default RelatedProducts;
